/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CandidateEmailMarkAsReadPathParams,
	CandidateEmailMarkAsReadRequest,
	CandidateEmailMarkAsReadResponse,
} from '../types/CandidateEmailMarkAsRead'

/**
 * POST /candidates/:candidateId/emails/read
 * @see backend/nexus/modules/Campaign/Http/Controllers/CandidateEmailController.php CandidateEmailController::markAsRead
 */
export async function candidateEmailMarkAsRead(
	candidateId: CandidateEmailMarkAsReadPathParams['candidateId'],
	data: CandidateEmailMarkAsReadRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateEmailMarkAsReadResponse>> {
	return axiosInstance.post(`/candidates/${candidateId}/emails/read`, data, config)
}
